module.exports = __webpack_public_path__ + "img/gift5-03-c1.d3eb25fb.png";